module.exports = __webpack_public_path__ + "img/Logo.e584fa38.svg";